<ng-container [ngSwitch]="range.isEmpty">
  <ng-container *ngSwitchCase="true">Any time</ng-container>
  <ng-container *ngSwitchCase="false">
    <ng-container *ngIf="range.min | date as startDate">
      Starts {{ startDate | date }}</ng-container
    >
    <ng-container *ngIf="range.min && range.max"> — </ng-container>
    <ng-container *ngIf="range.max as endDate">
      Ends {{ endDate | date }}</ng-container
    >
  </ng-container>
</ng-container>
